<template>
    <div class="p-4">
      <h1 class="text-xl font-bold mb-4">Hashing Tools</h1>
  
      <div class="mb-4">
        <textarea v-model="inputText" class="w-full h-32 p-3 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50" placeholder="Enter text here"></textarea>
      </div>
  
      <div class="mb-4">
        <select v-model="selectedAlgorithm" class="w-full p-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50">
          <option value="MD5">MD5</option>
          <option value="SHA1">SHA-1</option>
          <option value="SHA256">SHA-256</option>
          <option value="SHA384">SHA-384</option>
          <option value="SHA512">SHA-512</option>
          <option value="SHA3">SHA-3</option>
          <!-- Add more algorithms if needed -->
        </select>
      </div>
  
      <button @click="generateHash" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
        Generate Hash
      </button>
  
      <div v-if="generatedHash" class="mt-4">
        <p class="p-4 bg-slate-900 border border-slate-700 rounded-lg text-slate-300 overflow-x-auto">Generated Hash: <strong class="text-white">{{ generatedHash }}</strong></p>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from 'vue';
  import CryptoJS from 'crypto-js';
  
  export default defineComponent({
    name: 'HashingTools',
    setup() {
      const inputText = ref('');
      const selectedAlgorithm = ref('MD5');
      const generatedHash = ref('');
  
      function generateHash() {
        switch (selectedAlgorithm.value) {
          case 'MD5':
            generatedHash.value = CryptoJS.MD5(inputText.value).toString();
            break;
          case 'SHA1':
            generatedHash.value = CryptoJS.SHA1(inputText.value).toString();
            break;
          case 'SHA256':
            generatedHash.value = CryptoJS.SHA256(inputText.value).toString();
            break;
          case 'SHA384':
            generatedHash.value = CryptoJS.SHA384(inputText.value).toString();
            break;
          case 'SHA512':
            generatedHash.value = CryptoJS.SHA512(inputText.value).toString();
            break;
          case 'SHA3':
            generatedHash.value = CryptoJS.SHA3(inputText.value).toString();
            break;
          // Add more cases for additional algorithms
          default:
            generatedHash.value = '';
        }
      }
  
      return { inputText, selectedAlgorithm, generatedHash, generateHash };
    }
  });
  </script>
  
  <style scoped>
  /* Tailwind utility classes handle most styling */
  </style>
  